<template>
  <v-col
    align-self="center"
    :cols="colonna.dimensione"
    :style="{
      backgroundColor: colonna.colore_colonna,
      padding: '5px',
    }"
  >
    <span v-if="colonna.oggetto.filter((o) => o.validita == 1).length > 0">
      <!-- Sezione per visualizzare l'oggetto -->
      <div
        :style="{ backgroundColor: colonna.colore_colonna }"
        v-for="(oggetto, i) in colonna.oggetto.filter((o) => o.validita == 1)"
        :key="i"
      >
        <!-- Se l'oggetto è un bottone -->
        <div
          v-if="
            oggetto.tipo_oggetto === 'B' &&
            chkVisibile(workorder, oggetto, true)
          "
        >
          <!--pulsante start/stop classico con la finestra di dialogo -->
          <span v-if="oggetto.text == 'Start/stop'">
            <!-- Bottone dello start -->
            <v-tooltip
              bottom
              v-if="
                workorder.ora_start == null ||
                (workorder.ora_start != null && workorder.ora_stop != null)
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :height="oggetto.font_size_icona + 30 + 'px'"
                  :width="oggetto.font_size_icona + 30 + 'px'"
                  v-bind="attrs"
                  v-on="on"
                  class="button my-1"
                  @click="
                    switchStartStop(
                      workorder,
                      '',
                      'on',
                      'dialog_on',
                      oggetto.fields
                    )
                  "
                  :color="'success'"
                  :disabled="
                    !chkAutorizzato(workorder, oggetto, true) ||
                    (workorder.view_disegno != 1 &&
                      workorder.id_disegno != null) ||
                    workorder.note_fase === true
                  "
                  tile
                >
                  <v-icon
                    :style="{
                      fontSize: oggetto.font_size_icona + 'px',
                    }"
                  >
                    mdi-play
                  </v-icon>
                </v-btn>
              </template>
              <span>Start</span>
            </v-tooltip>

            <!-- Bottone dello stop -->
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :height="oggetto.font_size_icona + 30 + 'px'"
                  :width="oggetto.font_size_icona + 30 + 'px'"
                  v-bind="attrs"
                  v-on="on"
                  class="button my-1"
                  @click="
                    switchStartStop(
                      workorder,
                      '',
                      'on',
                      'dialog_on',
                      oggetto.fields
                    )
                  "
                  :color="'error'"
                  :disabled="
                    !chkAutorizzato(workorder, oggetto, true) ||
                    (workorder.view_disegno != 1 &&
                      workorder.id_disegno != null) ||
                    workorder.note_fase === true
                  "
                  tile
                >
                  <v-icon
                    :style="{
                      fontSize: oggetto.font_size_icona + 'px',
                    }"
                  >
                    mdi-stop
                  </v-icon>
                </v-btn>
              </template>
              <span>Stop</span>
            </v-tooltip>
          </span>

          <!--pulsante start/stop con la finestra di dialogo degli elementi -->
          <span v-else-if="oggetto.text == 'Lavorazione Elementi'">
            <!-- Bottone dello start -->
            <!-- La seguente parentesi era parte delle condizioni di disabled, inserita in una catena di ||. 
            La condizione è stata rimossa il 14/05/2025 per richiesta di Alberto in quanto si ritiene che 
            il sistema non ne abbia più bisogno, inparticolare per rispondere alle esigenze di Ferrara Quarzi. 
            (workorder.view_disegno != 1 && workorder.id_disegno != null) -->
            <v-tooltip
              bottom
              v-if="
                workorder.ora_start == null ||
                (workorder.ora_start != null && workorder.ora_stop != null)
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :height="oggetto.font_size_icona + 30 + 'px'"
                  :width="oggetto.font_size_icona + 30 + 'px'"
                  v-bind="attrs"
                  v-on="on"
                  class="button my-1"
                  @click="
                    switchStartStop(
                      workorder,
                      '',
                      'on',
                      'dialog_elementi',
                      oggetto.fields
                    )
                  "
                  :color="'success'"
                  :disabled="
                    !chkAutorizzato(workorder, oggetto, true) ||
                    workorder.note_fase === true
                  "
                  tile
                >
                  <v-icon
                    :style="{
                      fontSize: oggetto.font_size_icona + 'px',
                    }"
                  >
                    mdi-play
                  </v-icon>
                </v-btn>
              </template>
              <span>Start</span>
            </v-tooltip>

            <!-- Bottone dello stop -->
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :height="oggetto.font_size_icona + 30 + 'px'"
                  :width="oggetto.font_size_icona + 30 + 'px'"
                  v-bind="attrs"
                  v-on="on"
                  class="button my-1"
                  @click="
                    switchStartStop(
                      workorder,
                      '',
                      'on',
                      'dialog_elementi',
                      oggetto.fields
                    )
                  "
                  :color="'error'"
                  :disabled="
                    !chkAutorizzato(workorder, oggetto, true) ||
                    workorder.note_fase === true
                  "
                  tile
                >
                  <v-icon
                    :style="{
                      fontSize: oggetto.font_size_icona + 'px',
                    }"
                  >
                    mdi-stop
                  </v-icon>
                </v-btn>
              </template>
              <span>Stop</span>
            </v-tooltip>
          </span>

          <!--pulsante start/stop senza la finestra di dialogo-->
          <!-- La seguente parentesi era parte delle condizioni di disabled, inserita in una catena di ||. 
            La condizione è stata rimossa il 14/05/2025 per richiesta di Alberto in quanto si ritiene che 
            il sistema non ne abbia più bisogno, inparticolare per rispondere alle esigenze di Ferrara Quarzi. 
            (workorder.view_disegno != 1 && workorder.id_disegno != null) -->
          <v-tooltip bottom v-else-if="oggetto.text == 'Rilevazione Tempi'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                v-bind="attrs"
                v-on="on"
                class="button my-1"
                @click="
                  switchStartStop(
                    workorder,
                    '',
                    'on',
                    'dialog_off',
                    oggetto.fields
                  )
                "
                :color="
                  workorder.ora_start == null ||
                  (workorder.ora_start != null && workorder.ora_stop != null)
                    ? 'success'
                    : 'error'
                "
                :disabled="
                  !chkAutorizzato(workorder, oggetto, true) ||
                  workorder.note_fase === true
                "
                tile
              >
                <v-icon
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                >
                  {{
                    workorder.ora_start == null ||
                    (workorder.ora_start != null && workorder.ora_stop != null)
                      ? "mdi-play"
                      : "mdi-stop"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              workorder.ora_start == null ||
              (workorder.ora_start != null && workorder.ora_stop != null)
                ? "Start"
                : "Stop"
            }}</span>
          </v-tooltip>

          <!-- Pulsante della visualizzazione disegni -->
          <v-tooltip
            bottom
            v-else-if="oggetto.text == 'Visualizzazione Disegni'"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                v-bind="attrs"
                v-on="on"
                class="button my-1"
                @click="clickVisualizzaDisegno(workorder, oggetto.fields)"
                :color="
                  workorder.id_disegno == null
                    ? 'grey lighten-5'
                    : workorder.view_disegno == true
                    ? 'primary'
                    : 'error'
                "
                :disabled="!chkAutorizzato(workorder, oggetto, true)"
                tile
              >
                <v-icon
                  :color="workorder.id_disegno == null ? 'primary' : 'white'"
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                >
                  {{
                    oggetto.icona !== null &&
                    oggetto.icona !== undefined &&
                    oggetto.icona !== ""
                      ? oggetto.icona
                      : "mdi-eye"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              oggetto.tooltip !== null &&
              oggetto.tooltip !== undefined &&
              oggetto.tooltip !== ""
                ? oggetto.tooltip
                : "Visualizza Disegno"
            }}</span>
          </v-tooltip>

          <!-- Pulsante delle note fase -->
          <v-tooltip bottom v-else-if="oggetto.text == 'Note Fase'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                v-bind="attrs"
                v-on="on"
                class="button my-1"
                @click="clickNoteFase(workorder, oggetto.fields)"
                :color="
                  workorder.view_fase == 0 || workorder.view_fase == null
                    ? 'grey lighten-5'
                    : 'error'
                "
                :disabled="!chkAutorizzato(workorder, oggetto, true)"
                tile
              >
                <v-icon
                  :color="
                    workorder.view_fase == 0 || workorder.view_fase == null
                      ? 'primary'
                      : 'white'
                  "
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                >
                  {{
                    oggetto.icona !== null &&
                    oggetto.icona !== undefined &&
                    oggetto.icona !== ""
                      ? oggetto.icona
                      : "mdi-file-cog-outline"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              oggetto.tooltip !== null &&
              oggetto.tooltip !== undefined &&
              oggetto.tooltip !== ""
                ? oggetto.tooltip
                : "Note Fase"
            }}</span>
          </v-tooltip>

          <!-- Bottone del ciclo Autocontrollo -->
          <v-tooltip
            bottom
            v-else-if="
              oggetto.text == 'Controllo Qualità' ||
              oggetto.text == 'Campionatura' ||
              oggetto.text == 'Controllo Inizio Lotto MP'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                class="button my-1"
                :color="oggetto.colore_sfondo"
                :disabled="!chkAutorizzato(workorder, oggetto, true)"
                @click="clickControlloQualita(workorder, oggetto.fields)"
                tile
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  :color="oggetto.colore_icona"
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                >
                  {{
                    oggetto.icona !== null &&
                    oggetto.icona !== undefined &&
                    oggetto.icona !== ""
                      ? oggetto.icona
                      : "mdi-file-certificate"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>
              {{
                oggetto.tooltip !== null &&
                oggetto.tooltip !== undefined &&
                oggetto.tooltip !== ""
                  ? oggetto.tooltip
                  : "Controllo Qualità"
              }}
            </span>
          </v-tooltip>

          <!-- Bottone del ciclo Dichiarazione Componenti -->
          <v-tooltip bottom v-else-if="oggetto.text == 'Gestione lotti'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                class="button my-1"
                @click="clickPrelievi(workorder, oggetto.fields)"
                tile
                v-bind="attrs"
                v-on="on"
                :disabled="
                  workorder.materia_prima == 0 ||
                  !chkAutorizzato(workorder, oggetto, true)
                "
              >
                <v-icon
                  :color="workorder.flag_picking == 1 ? 'success' : 'primary'"
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                >
                  {{
                    oggetto.icona !== null &&
                    oggetto.icona !== undefined &&
                    oggetto.icona !== ""
                      ? oggetto.icona
                      : "mdi-warehouse"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>
              {{
                oggetto.tooltip !== null &&
                oggetto.tooltip !== undefined &&
                oggetto.tooltip !== ""
                  ? oggetto.tooltip
                  : "Dichiarazione Componente"
              }}
            </span>
          </v-tooltip>

          <!-- Bottone dello storico Prelievi -->
          <v-tooltip bottom v-else-if="oggetto.text == 'Storico Prelievi'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                class="button my-1"
                color="grey lighten-2"
                :disabled="
                  workorder.materia_prima == 0 ||
                  !chkAutorizzato(workorder, oggetto, true)
                "
                tile
                @click="clickStoricoPrelievi(workorder, oggetto.fields)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  :color="oggetto.colore_icona"
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                >
                  {{
                    oggetto.icona !== null &&
                    oggetto.icona !== undefined &&
                    oggetto.icona !== ""
                      ? oggetto.icona
                      : "mdi-archive-clock-outline"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>
              {{
                oggetto.tooltip !== null &&
                oggetto.tooltip !== undefined &&
                oggetto.tooltip !== ""
                  ? oggetto.tooltip
                  : "Storico Prelievi"
              }}
            </span>
          </v-tooltip>

          <!-- Bottone della stampa -->
          <!-- :disabled="workorder.tipo_avanzamento > 0" -->
          <v-tooltip bottom v-else-if="oggetto.text == 'Registrazione Imballi'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                class="button my-1"
                @click="clickStampaEtichetta(workorder, oggetto.fields)"
                :disabled="
                  workorder.tipo_avanzamento != 4 ||
                  !chkAutorizzato(workorder, oggetto, true)
                "
                tile
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  :color="oggetto.colore_icona"
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                >
                  {{
                    oggetto.icona !== null &&
                    oggetto.icona !== undefined &&
                    oggetto.icona !== ""
                      ? oggetto.icona
                      : "mdi-printer-settings"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span
              >{{
                oggetto.tooltip !== null &&
                oggetto.tooltip !== undefined &&
                oggetto.tooltip !== ""
                  ? oggetto.tooltip
                  : "Dichiarazione Imballi"
              }}
            </span>
          </v-tooltip>

          <!-- Bottone della registrazione packaging -->
          <v-tooltip bottom v-else-if="oggetto.text == 'Avanzamento Packaging'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                class="button my-1"
                @click="clickAvanzaContenitore(workorder, oggetto.fields)"
                :color="oggetto.colore_sfondo"
                :disabled="
                  workorder.tipo_avanzamento != 2 ||
                  !chkAutorizzato(workorder, oggetto, true)
                "
                tile
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  :color="oggetto.colore_icona"
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                >
                  {{
                    oggetto.icona !== null &&
                    oggetto.icona !== undefined &&
                    oggetto.icona !== ""
                      ? oggetto.icona
                      : "mdi-package-variant-closed"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span
              >{{
                oggetto.tooltip !== null &&
                oggetto.tooltip !== undefined &&
                oggetto.tooltip !== ""
                  ? oggetto.tooltip
                  : "Avanzamento Packaging"
              }}
            </span>
          </v-tooltip>

          <!-- Bottone dell'Avanzamento Contenitori SF -->
          <v-tooltip
            bottom
            v-else-if="oggetto.text == 'Avanzamento Contenitori SF'"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                class="button my-1"
                @click="clickAvanzaContenitoreSF(workorder, oggetto.fields)"
                :color="oggetto.colore_sfondo"
                :disabled="
                  workorder.tipo_avanzamento != 2 ||
                  !chkAutorizzato(workorder, oggetto, true)
                "
                tile
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  :color="oggetto.colore_icona"
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                >
                  {{
                    oggetto.icona !== null &&
                    oggetto.icona !== undefined &&
                    oggetto.icona !== ""
                      ? oggetto.icona
                      : "mdi-package-variant-closed"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span
              >{{
                oggetto.tooltip !== null &&
                oggetto.tooltip !== undefined &&
                oggetto.tooltip !== ""
                  ? oggetto.tooltip
                  : "Avanzamento Contenitori"
              }}
            </span>
          </v-tooltip>

          <!-- Bottone della registrazione confezioni -->
          <v-tooltip
            bottom
            v-else-if="oggetto.text == 'Avanzamento Confezioni'"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                class="button my-1"
                @click="clickAvanzaConfezioni(workorder, oggetto.fields)"
                :color="oggetto.colore_sfondo"
                :disabled="
                  workorder.tipo_avanzamento != 2 ||
                  !chkAutorizzato(workorder, oggetto, true)
                "
                tile
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  :color="oggetto.colore_icona"
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                >
                  {{
                    oggetto.icona !== null &&
                    oggetto.icona !== undefined &&
                    oggetto.icona !== ""
                      ? oggetto.icona
                      : "mdi-cube-send"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span
              >{{
                oggetto.tooltip !== null &&
                oggetto.tooltip !== undefined &&
                oggetto.tooltip !== ""
                  ? oggetto.tooltip
                  : "Avanzamento Confezioni"
              }}
            </span>
          </v-tooltip>

          <!--pulsante visualizza distinta base-->
          <v-tooltip
            bottom
            v-else-if="oggetto.text == 'Visualizzazione Distinta Base'"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                v-bind="attrs"
                v-on="on"
                class="button my-1"
                :color="oggetto.colore_sfondo"
                @click="btnClick(oggetto.text, workorder, oggetto.fields)"
                tile
                :disabled="
                  workorder.righe_movimenti > 0 ||
                  !chkAutorizzato(workorder, oggetto, true)
                "
              >
                <v-icon
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                  :color="oggetto.colore_icona"
                >
                  {{ oggetto.icona }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ oggetto.tooltip }}</span>
          </v-tooltip>

          <!--pulsante del Questionario Qualità -->
          <v-tooltip bottom v-else-if="oggetto.text == 'Questionario Qualita'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                v-bind="attrs"
                v-on="on"
                class="button my-1"
                :color="oggetto.colore_sfondo"
                @click="clickQuestionarioQualita(workorder)"
                tile
                :disabled="!chkAutorizzato(workorder, oggetto, true)"
              >
                <v-icon
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                  :color="oggetto.colore_icona"
                >
                  {{ oggetto.icona }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ oggetto.tooltip }}</span>
          </v-tooltip>

          <!--pulsante del Ciclo di Autocontrollo -->
          <v-tooltip bottom v-else-if="oggetto.text == 'Controllo'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                v-bind="attrs"
                v-on="on"
                class="button my-1"
                :color="oggetto.colore_sfondo"
                @click="
                  btnClick(
                    oggetto.text,
                    workorder,
                    oggetto.fields,
                    oggetto.query
                  )
                "
                tile
                :disabled="
                  !chkAutorizzato(workorder, oggetto, true) ||
                  (workorder.ora_start == null &&
                    workorder.ora_stop == null &&
                    oggetto.text == 'Controllo') ||
                  workorder.controllo == 0
                "
              >
                <v-icon
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                  :color="oggetto.colore_icona"
                >
                  {{ oggetto.icona }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ oggetto.tooltip }} </span>
          </v-tooltip>

          <!--pulsante generico-->
          <v-tooltip bottom v-else-if="oggetto.text != 'Avvio Multiplo WO'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :height="oggetto.font_size_icona + 30 + 'px'"
                :width="oggetto.font_size_icona + 30 + 'px'"
                v-bind="attrs"
                v-on="on"
                class="button my-1"
                :color="oggetto.colore_sfondo"
                @click="
                  btnClick(
                    oggetto.text,
                    workorder,
                    oggetto.fields,
                    oggetto.query
                  )
                "
                :disabled="
                  !chkAutorizzato(workorder, oggetto, true) ||
                  (workorder.ora_start == null &&
                    workorder.ora_stop == null &&
                    (oggetto.text == oggetto.text) == 'Esecuzione Campionatura')
                "
                tile
              >
                <v-icon
                  :style="{
                    fontSize: oggetto.font_size_icona + 'px',
                  }"
                  :color="oggetto.colore_icona"
                >
                  {{ oggetto.icona }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ oggetto.tooltip }}</span>
          </v-tooltip>

          <!--<v-btn
          :color="
            oggetto.colore_sfondo
          "
          :height="
            oggetto.font_size_icona +
            30 +
            'px'
          "
          :width="
            oggetto.font_size_icona +
            30 +
            'px'
          "
          tile
        >
          <v-icon
            :color="
              oggetto.colore_icona
            "
            :style="{
              fontSize:
                oggetto
                  .font_size_icona + 'px',
            }"
          >
            {{ oggetto.icona }}
          </v-icon>
        </v-btn>-->
        </div>

        <!-- Se l'oggetto è un dato -->
        <v-card
          :class="`elevation-${colonna.elevata == 1 ? '2' : '0'}`"
          :style="{
            display: 'inline-block',
            background: colonna.colore_sfondo,
            padding: '10px',
          }"
          v-else-if="
            oggetto.tipo_oggetto === 'D' &&
            chkAutorizzato(workorder, oggetto, true)
          "
        >
          <!-- Titolo del dato -->
          <span
            :style="{
              color: oggetto.font_color_titolo,
              fontSize: oggetto.font_size_titolo + 'px',
              fontWeight: oggetto.font_weight_titolo,
            }"
          >
            {{ oggetto.tooltip }}
          </span>
          <br />
          <!-- Valore del dato -->
          <span
            :style="{
              color: oggetto.font_color_dato,
              fontSize: oggetto.font_size_dato + 'px',
              fontWeight: oggetto.font_weight_dato,
            }"
          >
            {{ workorder[oggetto.value] }}

            <!-- Vecchio costrutto ternario per formattare la data. -->
            <!--
            oggetto.value ==
              "ora_start" ||
            oggetto.value ==
              "ora_stop"
              ? formatData(
                  workorder[
                    oggetto.value
                  ]
                )
              : workorder[oggetto.value]
          -->
          </span>
        </v-card>

        <!-- Se l'oggetto è un'immagine -->
        <div
          v-else-if="oggetto.tipo_oggetto === 'I'"
          :style="{
            height: img_h + 'px !important',
            textAlign: 'center',
          }"
        >
          <img
            aspect-ratio="1"
            @click="showImageViewer"
            :lazy-src="workorder.immagine_preview"
            :src="workorder.immagine_preview"
            :style="{
              display: 'inline-block !important',
              height: img_h + 'px !important',
              width: img_w + 'px !important',
            }"
          />
        </div>

        <!-- Se l'oggetto è una notifica -->
        <v-card
          :class="`elevation-${colonna.elevata == 1 ? '2' : '0'}`"
          :style="{
            display: 'inline-block',
            background: oggetto.colore_sfondo,
            padding: '10px',
          }"
          v-else-if="
            oggetto.tipo_oggetto === 'N' &&
            chkAutorizzato(workorder, oggetto, false)
          "
        >
          <!-- Testo della notifica -->
          <span
            :style="{
              color: oggetto.font_color_dato,
              fontSize: oggetto.font_size_dato + 'px',
              fontWeight: oggetto.font_weight_dato,
            }"
          >
            {{ oggetto.tooltip }}
          </span>
        </v-card>
      </div>
    </span>

    <!-- Sezione per visualizzare una riga -->
    <v-container fluid v-else>
      <ProduzioneLayoutRow
        @click_allegati_commessa="handleClickAllegatiCommessa"
        @click_chiusura_massiva_fasi="handleClickChiusuraMassivaFasi"
        @click_registra_art_res="handleClickRegistraArtRes"
        @click_registra_peso="handleClickRegistraPeso"
        @click_riapertura_master="handleClickRiaperturaMaster"
        @click_allegati_fase="handleClickAllegatiFase"
        @click_applicazione_loghi="handleClickApplicazioneLoghi"
        @click_avanza_confezioni="handleClickAvanzaConfezioni"
        @click_avanza_contenitore="handleClickAvanzaContenitore"
        @click_avanza_contenitore_sf="handleClickAvanzaContenitoreSF"
        @click_check="transmitClickCheck"
        @click_questionario_qualita="handleClickQuestionarioQualita"
        @click_campionatura="handleClickCampionatura"
        @click_cchiusura_fase="handleClickChiusuraFase"
        @click_controllo_mp="handleClickControlloMP"
        @click_controllo_qualita="handleClickControlloQualita"
        @click_gestione_pulsanti="handleClickGestionePulsanti"
        @click_history="handleClickHistory"
        @click_lavoro_squadra="handleClickLavoroSquadra"
        @click_nascondi="handleClickNascondi"
        @click_note_commessa="handleClickNoteCommessa"
        @click_note_fase="handleClickNoteFase"
        @click_note_fase_precedente="handleClickNoteFasePrecedente"
        @click_prelievi="handleClickPrelievi"
        @click_registra_imballi="handleClickRegistraImballi"
        @click_registra_pezzi="handleClickRegistraPezzi"
        @click_manutenzione="handleClickManutenzione"
        @click_registra_fermi="handleClickRegistraFermi"
        @click_registra_pezzi_alternativi="handleClickRegistraPezziAlternativi"
        @click_registra_pezzi_seriali="handleClickRegistraPezziSeriali"
        @click_registra_scarti="handleClickRegistraScarti"
        @click_registra_cont_alternativi="handleClickRegistraContAlternativi"
        @click_ristampa_seriale="handleClickRistampaSeriale"
        @click_segnalazione="handleClickSegnalazione"
        @click_visualizza_allegto_controllo="
          handleClickVisualizzaAllegatoControllo
        "
        @click_visualizza_disegno="handleClickVisualizzaDisegno"
        @click_scheda_packaging="handleClickSchedaPackaging"
        @click_scheda_richieste="handleClickSchedaRichieste"
        @click_start="handleClickStart"
        @click_stop="handleClickStop"
        @click_subentro="handleClickSubentro"
        @column_is_mounted="handleColumnIsMounted"
        :gestione_team_enabled="gestione_team_enabled"
        :handleClickCheck="handleClickCheck"
        :key="i"
        :riga="riga"
        v-for="(riga, i) in colonna.righe.filter((r) => r.validita == 1)"
        :workorder="workorder"
      ></ProduzioneLayoutRow>
    </v-container>

    <!-- Spazio per la snackbar e per i caspita di dialog -->
    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-icon class="ruota" size="100">mdi-cog</v-icon>
      <v-icon class="controruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!--Dialog Visualizzazione Distinta Base-->
    <v-dialog v-model="dialogDistintaBase" width="80vw">
      <v-card>
        <v-toolbar class="white--text" color="indigo" dense>
          <v-toolbar-title> Distinta Base </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="
                  dialogDistintaBase = false;
                  performPopQuery(createStdQueryArr(workorder));
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <WODistintaBase
          :idCommessa="distintaItem != null ? distintaItem.id_commessa : -1"
          :key="key_distinta_base"
        >
        </WODistintaBase>
      </v-card>
    </v-dialog>

    <!-- Dialog Prova Tabella Custom -->
    <v-dialog v-model="visualizza_dialog_tabella_custom" width="unset">
      <TabelleCustomList
        @click_indietro="visualizza_dialog_tabella_custom = false"
        :modulo="'AVANZAMENTO'"
        :workorder="workorder_sel"
        :visualizza_dialog_tabella_custom="visualizza_dialog_tabella_custom"
      />
    </v-dialog>

    <v-dialog v-model="placingDialog" width="50vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Crea Placing </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="assignUbicazionePlacing" small>
            <v-icon color="primary"> mdi-warehouse </v-icon>
          </v-btn>
          <v-btn
            @click="confirmPlacing"
            small
            class="ml-5"
            :disabled="
              !(
                qntPlacing > 0 &&
                qntPlacing <= placingItem.quantita &&
                ubicazionePlacing.id_magazzino_ubicazione != -1 &&
                !loading
              )
            "
          >
            <v-icon color="success"> mdi-check </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="mr-5" @click="closePlacing" small>
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="cyan"
          v-if="loading"
          id="progress"
        >
        </v-progress-linear>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-text-field
                label="Disponobile"
                readonly
                v-model="placingItem.quantita"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field label="Quantita" v-model="qntPlacing" type="number">
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                label="Ubicazione"
                v-model="ubicazionePlacing.path"
                readonly
                append-outer-icon="mdi-pencil"
                @click:append-outer="selectPlacingUbicazione"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma prima del salvataggio -->
    <v-dialog v-model="conferma_nascondi" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler nascondere il WO
            <b>{{ workorder_sel.cod_fase }} - {{ workorder_sel.des_fase }}</b>
            della commessa <b>{{ workorder_sel.cod_commessa }}</b
            >?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="conferma_nascondi = false" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="nascondiWO" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_storico_prelievi" width="unset">
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">
          Storico Prelievi
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="closeStoricoPrelievi" small v-bind="attrs" v-on="on">
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-data-table :headers="headers_storico" :items="items_storico_prelievo">
      </v-data-table>
    </v-dialog>

    <v-dialog v-model="partProgramDialog" width="75vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Invia Part Program
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mr-5" @click="sendPartProgram" small>
            <v-icon color="success"> mdi-send </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="mr-5" @click="chiudiInvioPartProgram" small>
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <GestioneFasiValori
            :id_macchina="idMacchinaTemp"
            :access="2"
            :id_commessa_dettaglio="id_commessa_dettaglio"
            ref="GestioneFasiValori"
          />
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="StampaEttichetaDialog" width="75vw" persistent>
      <StampaEtichettaVue
        @click_chiudi="
          StampaEttichetaDialog = false;
          uniqueKey = null;
          performPopQuery(createStdQueryArr(workorder));
        "
        :id_ArticoloTemp="idArticoloTemp"
        :idCommessaDettaglio="id_commessa_dettaglio"
        :key="uniqueKey"
        :workorder="workorder"
      />
    </v-dialog>
    <v-dialog v-model="graphDialog" width="80vw">
      <v-toolbar class="white--text" color="indigo" dense>
        <v-toolbar-title>Quick Graph</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="graphDialog = false"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-card height="80vh" style="overflow-y: scroll">
        <WindowFrame component="graph" :input_args="graphArgs"> </WindowFrame>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import moment from "moment/moment";
import GestioneFasiValori from "@/components/INDUSTRIA_4.0/Gestione Part Program/GestioneFasiValori.vue";
import ProduzioneColumnObject from "@/classes/ProduzioneColumnObject.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import StampaEtichettaVue from "@/components/PRODUCTION/ProduzioneInsit/StampaEtichetta.vue";
import TabelleCustomList from "@/components/TABELLA_CUSTOM/TabelleCustomList.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import WODistintaBase from "@/components/PRODUCTION/ProduzioneInsit/WODistintaBase.vue";

class Workorder {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "autonoma", default_val: null },
      { nome: "cod_macchina", default_val: "" },
      { nome: "costo_orario", default_val: null },
      { nome: "data_acquisto", default_val: "" },
      { nome: "des_centrocosto", default_val: "" },
      { nome: "des_connessione", default_val: "" },
      { nome: "des_funzione", default_val: "" },
      { nome: "des_macchina", default_val: "" },
      { nome: "des_stato", default_val: "" },
      { nome: "des_reparto", default_val: "" },
      { nome: "fine_garanzia", default_val: "" },
      { nome: "flag_4_0", default_val: null },
      { nome: "id_centrocosto", default_val: null },
      { nome: "id_funzione", default_val: null },
      { nome: "id_macchina", default_val: null },
      { nome: "id_reparto", default_val: null },
      { nome: "id_stato", default_val: null },
      { nome: "id_tipo_get_macchina", default_val: null },
      { nome: "inizio_garanzia", default_val: "" },
      { nome: "macchina_img", default_val: "" },
      { nome: "marca", default_val: "" },
      { nome: "matricola", default_val: "" },
      { nome: "modello", default_val: "" },
      { nome: "multi_commessa", default_val: null },
      { nome: "on_line", default_val: null },
      { nome: "ore_disponibilita", default_val: null },
      { nome: "schedula", default_val: null },
      { nome: "specifiche", default_val: null },
      { nome: "tipo_connessione", default_val: null },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "ProduzioneLayoutColumn",
  components: {
    ProduzioneLayoutRow: () =>
      import(
        "@/components/PRODUCTION/ProduzioneLayout/ProduzioneLayoutRow.vue"
      ),

    SnackbarQV,
    WindowFrame,
    TabelleCustomList,
    StampaEtichettaVue,
    GestioneFasiValori,
    WODistintaBase,
  },
  props: {
    colonna: { type: Object, default: () => new ProduzioneColumnObject() },
    gestione_team_enabled: { type: Number, default: 0 },
    handleClickCheck: {
      type: Function,
      default: () => {},
    },
    workorder: { type: Object, default: () => {} },
  },
  data() {
    return {
      // Variabili d'appoggio
      graphArgs: {
        evento_target: "load_dashboard",
        payload: {
          show_overall: false,
          version: 0,
          dashboard: -1,
          params: [],
        },
      },
      graphDialog: false,
      id_articolo_sel: null,
      image_for_viewer: "",
      img_h: 0,
      img_w: 0,
      workorder_sel: new Workorder(),
      distintaItem: null,

      // Modal
      // Variabli for Stampa Modal and Part Program
      partProgramDialog: false,
      StampaEttichetaDialog: false,
      idMacchinaTemp: null,
      idArticoloTemp: null,
      id_commessa_dettaglio: null,
      uniqueKey: null,
      //End Variabli of Stampa Modal

      key_distinta_base: 0,
      dialogDistintaBase: false,
      loading: false,
      ubicazionePlacing: { id_magazzino_ubicazione: -1, path: "Nessuno" },
      qntPlacing: 0,
      placingDialog: false,
      avanzamento_packaging_visible: 0,
      conferma_nascondi: false,
      dialog_stampa: false,
      dialog_storico_prelievi: false,
      esecuzione_controllo_visible: 0,
      gestione_lotti_visible: 0,
      nascondi_wo_visible: 0,
      registrazione_visible: 0,
      start_stop_visible: 0,
      stato: true,
      subentro_visible: 0,
      overlay: false,
      visualizza_dialog_tabella_custom: false,
      visualizza_disegni_visible: 0,
      placingItem: { quantita: 0 },
      CommessaData: null,

      // Array
      items_storico_prelievo: [],
      items_info_wo: [],
      headers_storico: [
        { text: "Cod. Lotto", value: "cod_lotto" },
        { text: "Cod. Articolo", value: "cod_articolo" },
        { text: "Des: Articolo", value: "des_articolo" },
        { text: "Qta Impegno", value: "quantita_impegno" },
        { text: "Qta Prelevata", value: "quantita_prelevato" },
      ],
      rows: [{ pulsanti: [] }],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      async handler() {
        /* Se il mio WO ha un'immagine e se la mia colonna deve
         * renderizzare un oggetto immagine, calcolo larghezza
         * e altezza della miniatura. */
        if (
          this.workorder &&
          this.workorder.immagine_preview &&
          this.colonna.oggetto.filter((o) => o.validita == 1).length > 0
        ) {
          this.img_h = await this.getMiniaturaH(
            this.workorder.immagine_preview,
            this.colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_size_icona
          );
          this.img_w = await this.getMiniaturaW(
            this.workorder.immagine_preview,
            this.colonna.oggetto.filter((o) => o.validita == 1)[0]
              .font_size_icona
          );
        }
      },
    },
  },
  methods: {
    handleClickAllegatiCommessa(arg) {
      this.$emit("click_allegati_commessa", arg);
    },
    async assignUbicazionePlacing() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getassignubicazioni",
          token: localStorage.user_token,
          articoli: [
            {
              id_articolo: this.placingItem.id_articolo,
              id_famiglia: -1,
              id_sub_famiglia: -1,
            },
          ],
        },
      };
      await this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          if (
            res.data.result[this.placingItem.id_articolo.toString()].length > 0
          ) {
            this.ubicazionePlacing =
              res.data.result[this.placingItem.id_articolo.toString()][0];
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Nessun ubicazione disponibile"
            );
          }
        }
      });
    },
    async btnClick(text, item, codice_btn, query = -1) {
      // Controllo che non ci siano questionari a cui rispondere.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.btnClick(text, item, codice_btn);
        },
      };

      const res = await this.handleClickCheck(item, codice_btn, stack_obj);

      if (res === "S") {
        return;
      }

      // Se non ho questionari a cui rispondere vado avanti con la logica normale.
      if (text == "Allegati Fase") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.$emit("click_allegati_fase", item);
      } else if (text == "Registra Art. Res.") {
        /* Apro i controlli di qualità solo se il WO è in stato di
         * start, se è in  stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Avviare la lavorazione per eseguire le verifiche di qualità."
          );
          return;
        }

        this.$emit("click_registra_art_res", item);
      } else if (text == "Note Fase Precedente") {
        /* Apro le note solo se il WO è in stato di
         * start, se è in  stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Avviare la lavorazione per vedere le note della fase precedente."
          );
          return;
        }
        this.$emit("click_note_fase_precedente", item);
      } else if (text == "Chiusura Massiva Fasi") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.$emit("click_chiusura_massiva_fasi", item);
      } else if (text == "Avanzamento Carrello") {
        /* Apro i controlli di qualità solo se il WO è in stato di
         * start, se è in  stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Avviare la lavorazione per eseguire le verifiche di qualità."
          );
          return;
        }

        this.$emit("click_registra_peso", item);
      } else if (text == "Riapertura Master") {
        // Eseguo la riapertura master solo se sto lavorando.
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Avviare la lavorazione per eseguire le verifiche di qualità."
          );
          return;
        }

        this.$emit("click_riapertura_master", item);
      } else if (text == "Check") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.$emit("click_check", item, codice_btn);
      } else if (text == "Invia Part Program") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.performPreQuery("IPP", this.createStdQueryArr(item));
        this.id_commessa_dettaglio = item.id_commessa_dettaglio;
        this.idMacchinaTemp = item.id_macchina;
        this.partProgramDialog = true;
      } else if (text == "Stampa etichetta") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        // Eseguo la prequery.
        this.performPreQuery("PRTETICH", this.createStdQueryArr(item));

        // Procedo con la logica del pulsante.
        this.uniqueKey = 1;
        this.idArticoloTemp = item.id_articolo;
        this.idMacchinaTemp = item.id_macchina;
        this.id_commessa_dettaglio = item.id_commessa_dettaglio;
        this.StampaEttichetaDialog = true;
      } else if (
        text == "Controllo" ||
        text == "Campionatura" ||
        text == "Controllo MP" ||
        text == "Chiusura Fase"
      ) {
        /* Apro i controlli di qualità solo se il WO è in stato di
         * start, se è in  stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Avviare la lavorazione per eseguire le verifiche di qualità."
          );
          return;
        }

        /* Il ciclo di autocontrollo e la campionatura li gestisco allo stesso modo qui, in effetti
         * il metodo che richiamo distingue i due bottoni ed emette due eventi distinti che lanciano
         * configurazioni diverse dello stesso flusso operativo. */
        this.clickControlloQualita(item, codice_btn);
      } else if (text == "Lavoro Squadra") {
        /* Gestisco il team solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Il team può essere gestito solo quando la lavorazione è attiva."
          );
          return;
        }
        this.$emit("click_lavoro_squadra", item);
      } else if (text == "Note Commessa") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.$emit("click_note_commessa", item);
      } else if (text == "NascondiWO") {
        this.clickNascondi(item);
      } else if (text == "Crea Placing") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.clickPlacing(item);
      } else if (text == "Registrazione Alternativa") {
        /* Registro i pezzi solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "I pezzi prodotti possono essere registrati solo quando la lavorazione è attiva."
          );
        } else {
          this.clickRegistraPezziAlternativi(item);
        }
      } else if (text == "Registrazione Pezzi") {
        /* Registro i pezzi solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "I pezzi prodotti possono essere registrati solo quando la lavorazione è attiva."
          );
        } else {
          this.clickRegistraPezzi(item);
        }
      } else if (text == "Dichiarazione Seriale") {
        /* Registro i pezzi solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "I pezzi prodotti possono essere registrati solo quando la lavorazione è attiva."
          );
        } else {
          this.handleClickRegistraPezziSeriali(item);
        }
      } else if (text == "Ristampa Seriale") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.handleClickRistampaSeriale(item);
      } else if (text == "Richiesta Manutenzione") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.clickManutenzione(item);
      } else if (text == "Dichiarazione Scarti") {
        /* Registro gli scarti solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Gli scarti possono essere registrati solo quando la lavorazione è attiva."
          );
        } else {
          this.clickRegistraScarti(item);
        }
      } else if (text == "Dichiarazione Fermi") {
        /* Registro gli scarti solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "I fermi possono essere registrati solo quando la lavorazione è attiva."
          );
        } else {
          this.clickRegistraFermi(item);
        }
      } else if (text == "Scheda Packaging") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.$emit("click_scheda_packaging", item);
      } else if (text == "Subentro") {
        this.clickSubentro(item);
      } else if (text == "Visualizzazione Disegni") {
        this.clickVisualizzaDisegno(item);
      } else if (text == "Richieste") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.$emit("click_scheda_richieste", item);
      } else if (text == "Visualizzazione Distinta Base") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.clickDistintaBase(item);
      } else if (text == "Apre Graph") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.clickGraph(item, codice_btn, query);
      } else if (text == "Segnalazioni") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.$emit("click_segnalazione", item);
      } else if (text == "Applicazione Loghi") {
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
          return;
        }

        this.$emit("click_applicazione_loghi", item);
      } else if (text == "Allegati Commessa") {
        /* Registro gli scarti solo se il WO è in stato di start,
         * se è in stato di stop o mai avviato invece stampo
         * una snackbar di avviso e non faccio nulla. */
        if (
          (item.ora_start == null && item.ora_stop == null) ||
          (item.ora_start != null && item.ora_stop != null)
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Gli allegati possono essere visionati solo quando la lavorazione è attiva."
          );
        } else {
          this.$emit("click_allegati_commessa", item);
        }
      }
    },
    chiudiInvioPartProgram() {
      this.partProgramDialog = false;

      // Eseguo la logica di postquery.
      this.performPopQuery(this.createStdQueryArr(this.workorder));
    },
    chkAutorizzato(workorder, oggetto, default_res_val) {
      if (workorder.autorizzazioni && oggetto.validita == 1) {
        return (
          workorder.autorizzazioni.filter(
            (a) => a.field == oggetto.fields && a.abilitato == 0
          ).length == 0
        );
      } else {
        return default_res_val;
      }
    },
    chkDisponibilita(arg) {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutentegenerale",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.filtroEM === "1" ? arg.cod_commessa : "",
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            let utilizzatore_macchina = null;
            res.data.workorders.workorder.forEach((w) => {
              /* Cerco il WO che mi interessa, se lo trovo
               * registro il suo utilizzatore_macchina. */

              /* Mando il nome dell'occupante se tutte le
               * seguenti condizioni sono verificate:
               * (1) se il WO non è multioperatore
               * (2) se il WO non è disponibile
               * (3) se gli ho già dato uno stop */
              if (
                w.id_commessa_dettaglio === arg.id_commessa_dettaglio &&
                arg.multioperatore === 0 &&
                arg.disponibile === 0 &&
                arg.ora_stop != null
              ) {
                utilizzatore_macchina = w.utilizzatore_macchina;
              }
            });

            // Ritorno il nome dell'utilizzatore che ho trovato.
            return utilizzatore_macchina;
          } else {
            return "";
          }
        })
        .catch((e) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore tecnico nel controllo dell'impegno Work Order."
          );
          console.error(e);
          return "";
        });
    },
    chkVisibile(workorder, oggetto, default_res_val) {
      if (workorder.autorizzazioni && oggetto.validita == 1) {
        return (
          workorder.autorizzazioni.filter(
            (a) => a.field == oggetto.fields && a.visibile == 0
          ).length == 0
        );
      } else {
        return default_res_val;
      }
    },
    async clickAvanzaConfezioni(item, arg_cod_pulsante) {
      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickAvanzaConfezioni(item, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(
        item,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      /* Registro i pezzi solo se il WO è in stato di start,
       * se è in stato di stop o mai avviato invece stampo
       * una snackbar di avviso e non faccio nulla. */
      if (
        (item.ora_start == null && item.ora_stop == null) ||
        (item.ora_start != null && item.ora_stop != null)
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Le confezioni possono essere avanzati solo quando la lavorazione è attiva."
        );
        return;
      }

      if (item.id_magazzino == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non c'è alcun magazzino predefinito per questo articolo, impossibile avanzare confezioni."
        );

        return;
      }

      this.$emit("click_avanza_confezioni", item);
    },
    async clickAvanzaContenitore(item, arg_cod_pulsante) {
      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickAvanzaContenitore(item, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(
        item,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      /* Registro i pezzi solo se il WO è in stato di start,
       * se è in stato di stop o mai avviato invece stampo
       * una snackbar di avviso e non faccio nulla. */
      if (
        (item.ora_start == null && item.ora_stop == null) ||
        (item.ora_start != null && item.ora_stop != null)
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "I contenitori possono essere avanzati solo quando la lavorazione è attiva."
        );
        return;
      }

      if (item.id_magazzino == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non c'è alcun magazzino predefinito per questo articolo, impossibile avanzare contenitori."
        );

        return;
      }

      this.$emit("click_avanza_contenitore", item);
    },
    async clickAvanzaContenitoreSF(item, arg_cod_pulsante) {
      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickAvanzaContenitoreSF(item, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(
        item,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      /* Registro i pezzi solo se il WO è in stato di start,
       * se è in stato di stop o mai avviato invece stampo
       * una snackbar di avviso e non faccio nulla. */
      if (
        (item.ora_start == null && item.ora_stop == null) ||
        (item.ora_start != null && item.ora_stop != null)
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "I contenitori possono essere avanzati solo quando la lavorazione è attiva."
        );
        return;
      }

      if (item.id_magazzino == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non c'è alcun magazzino predefinito per questo articolo, impossibile avanzare contenitori."
        );

        return;
      }

      this.$emit("click_avanza_contenitore_sf", item);
    },
    async clickControlloQualita(arg, arg_cod_pulsante) {
      if (
        (arg.ora_start == null && arg.ora_stop == null) ||
        (arg.ora_start != null && arg.ora_stop != null)
      ) {
        this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
        return;
      }

      /* Se il parametro controllo non è a 1, stampo una snackbar
       * di avviso per informare l'utente che non serve fare
       * un ciclo di autocontrollo e non faccio nulla. */
      // if (arg.controllo != 1) {
      //   this.$refs.SnackbarQV.print(
      //     "orange",
      //     "Nessun autocontrollo è attualmente richiesto per questo Work Order."
      //   );
      //   return;
      // }

      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickControlloQualita(arg, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(arg, arg_cod_pulsante, stack_obj);

      if (res === "S") {
        return;
      }

      if (arg_cod_pulsante === "CONTROLLO") {
        this.$emit("click_controllo_qualita", arg);
      } else if (arg_cod_pulsante === "CAMPIONATURA") {
        this.$emit("click_campionatura", arg);
      } else if (arg_cod_pulsante === "CONTROLLOMP") {
        this.$emit("click_controllo_mp", arg);
      } else if (arg_cod_pulsante === "CHIUFS") {
        this.$emit("click_chiusura_fase", arg);
      }
    },
    clickDistintaBase(item) {
      // Eseguo la prequery.
      this.performPreQuery("VBAS", this.createStdQueryArr(item));

      // Metto in atto la logica della procedura.
      this.distintaItem = JSON.parse(JSON.stringify(item));
      this.key_distinta_base = this.key_distinta_base == 1 ? 0 : 1;
      this.dialogDistintaBase = true;
    },
    async clickGraph(item) {
      let request = {
        controller: "graph",
        method: "POST",
        richiesta: {
          action: "getassociazioni",
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api6", request).then((res) => {
        const dashInfo = res.data.result.filter((e) => e.cod == "PLO")[0];
        this.graphArgs.payload.dashboard = dashInfo.id_dashboard;
        this.graphArgs.payload.params = [];

        if (
          typeof dashInfo.parametri != "undefined" &&
          dashInfo.parametri != null
        ) {
          for (const p of dashInfo.parametri.split(",")) {
            const p2 = p.replaceAll("$", "").trim();
            if (typeof item[p2] != "undefined" && item[p2] != null) {
              this.graphArgs.payload.params.push({
                simbolo: "$" + p2,
                valore: item[p2].toString(),
              });
            }
          }
        }
        this.graphKey = !this.graphKey;
        this.graphDialog = true;
      });
    },
    clickHistoryWO(arg) {
      this.$emit("click_history", arg);
    },
    clickNascondi(item) {
      /* Se l'utente non ha mai fatto uno start né uno stop
       * gli chiedo di farlo almeno una volta per nasconderlo. */
      if (
        (item.ora_stop == null || item.ora_stop == "") &&
        (item.ora_start == null || item.ora_start == "")
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Per nascondere il Work Order l'utente deve attivarlo almeno una volta."
        );
        return;
      }

      /* Se l'utente non ha mai fatto uno stop
       * gli chiedo di farlo prima di nasconderlo. */
      if (item.ora_stop == null || item.ora_stop == "") {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il Work Order deve essere fermato prima di essere nascosto."
        );
        return;
      }

      this.workorder_sel = JSON.parse(JSON.stringify(item));
      this.conferma_nascondi = true;
    },
    async clickNoteFase(arg, arg_cod_pulsante) {
      if (
        (arg.ora_start == null && arg.ora_stop == null) ||
        (arg.ora_start != null && arg.ora_stop != null)
      ) {
        this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
        return;
      }

      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickNoteFase(arg, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(arg, arg_cod_pulsante, stack_obj);

      if (res === "S") {
        return;
      }

      this.$emit("click_note_fase", arg);
    },
    clickPlacing(arg) {
      this.placingDialog = true;
      this.placingItem = arg;
    },
    async clickPrelievi(item, arg_cod_pulsante) {
      /* Se ora start e ora stop hanno dei valori nulli
       * vuol dire che non ho mai avviato il WO */
      if (
        item.ora_start == null ||
        item.ora_start == "" ||
        (item.ora_stop != null && item.ora_stop != "")
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Avviare il WO prima di gestire la maetria prima."
        );
        return;
      }

      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickPrelievi(item, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(
        item,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      this.$emit("click_prelievi", item);
    },
    async clickQuestionarioQualita(arg) {
      if (
        (arg.ora_start == null && arg.ora_stop == null) ||
        (arg.ora_start != null && arg.ora_stop != null)
      ) {
        this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
        return;
      }

      const getrelazioni_tmp = await this.getRelazioniModuli(
        arg.id_commessa_dettaglio,
        "QQUAL"
      );

      /* Il tasto del Questionario Qualità serve per
       * eseguire questionari di validazione delle
       * procedure di qualità. Se non c'è un questionario
       * legato a questo WO, non apro nulla, fermo la
       * logica e stampo un avviso. */
      if (getrelazioni_tmp.exec === "N") {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono questionari accessibili da questa funzionalità per questo Work Order."
        );
        return;
      }

      /* Se c'è un questionario da compilare emetto
       * il WO e i dati relativi al questionario. */
      this.$emit("click_questionario_qualita", arg, getrelazioni_tmp);
    },
    clickRegistraPezzi(item) {
      if (item.view_disegno != null) {
        this.$emit("click_registra_pezzi", item);
      } else {
        // Se non ho visto il disegno, stampo una snackbar di errore.
        this.$refs.SnackbarQV.print(
          "orange",
          "Visionare nuova modifica di disegno prima di dichiarare."
        );
      }
    },
    clickManutenzione(item) {
      this.$emit("click_manutenzione", item);
    },
    clickRegistraFermi(item) {
      this.$emit("click_registra_fermi", item);
    },
    clickRegistraPezziAlternativi(item) {
      if (item.view_disegno != null) {
        this.$emit("click_registra_cont_alternativi", item);
      } else {
        // Se non ho visto il disegno, stampo una snackbar di errore.
        this.$refs.SnackbarQV.print(
          "orange",
          "Visionare nuova modifica di disegno prima di dichiarare."
        );
      }
    },
    clickRegistraScarti(item) {
      if (item.view_disegno != null) {
        this.$emit("click_registra_scarti", item);
      } else {
        // Se non ho visto il disegno, stampo una snackbar di errore.
        this.$refs.SnackbarQV.print(
          "orange",
          "Visionare nuova modifica di disegno prima di dichiarare."
        );
      }
    },
    async clickStampaEtichetta(item, arg_cod_pulsante) {
      if (item.id_magazzino == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non c'è alcun magazzino predefinito per questo articolo, impossibile registrare imballi."
        );

        return;
      }

      /* Apro la registrazione imballi e la stampa etichette
       * solo se il WO è in stato di start, se è in  stato di
       * stop o mai avviato invece stampo una snackbar di avviso
       * e non faccio nulla. */
      if (
        (item.ora_start == null && item.ora_stop == null) ||
        (item.ora_start != null && item.ora_stop != null)
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Avviare la lavorazione per dichiarare gli imballi."
        );
        return;
      }

      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickStampaEtichetta(item, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(
        item,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      this.$emit("click_registra_imballi", item);
    },
    async clickStoricoPrelievi(item, arg_cod_pulsante) {
      if (
        (item.ora_start == null && item.ora_stop == null) ||
        (item.ora_start != null && item.ora_stop != null)
      ) {
        this.$refs.SnackbarQV.print("orange", "Avviare la lavorazione.");
        return;
      }

      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickStoricoPrelievi(item, arg_cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(
        item,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      // Eseguo la funzione di prequery.
      this.performPreQuery("LISTA", this.createStdQueryArr(item));

      // Procedo con la logica della procedura.
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getprelievicommessa",
          token: localStorage.getItem("user_token"),
          id_commessa_dettaglio: item.id_commessa_dettaglio,
          quantita: item.quantita,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.items_storico_prelievo = res.data.Prelievi;
      });

      this.dialog_storico_prelievi = true;
    },
    clickSubentro(item) {
      this.$emit("click_subentro", item);
    },
    clickVisualizzaAllegatoControllo(item) {
      this.$emit("click_visualizza_allegto_controllo", item);
    },
    async clickVisualizzaDisegno(item, cod_pulsante) {
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.clickVisualizzaDisegno(item, cod_pulsante);
        },
      };

      const res = await this.handleClickCheck(item, cod_pulsante, stack_obj);

      if (res === "S") {
        return;
      }

      /* Controllo che ci siano disegni da
       * visualizzare (me ne accorgo perché se
       * non ci sono id_disegno == null). */
      if (item.id_disegno == null) {
        // Se non ci sono disegni lancio una snackber di errore
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono disegni da visualizzare."
        );
      } else {
        /* Se ci sono disegni emetto normalmente l'evento,
         * così il componente padre apre il dialog dei disegni. */
        this.$emit("click_visualizza_disegno", item);
      }
    },
    clickVisualizzaTabella(item) {
      this.workorder_sel = item;
      this.visualizza_dialog_tabella_custom = true;
    },
    async confirmPlacing() {
      var movimento = {
        id_magazzino_movimenti: -1,
        id_articolo: this.placingItem.id_articolo,
        id_ubicazione: this.ubicazionePlacing.id_magazzino_ubicazione,
        id_commessa: this.placingItem.id_commessa,
        quantita: this.qntPlacing,
        cod_articolo: this.placingItem.cod_articolo,
        numero_seriale: -1,
        id_controllo: 0,
      };
      this.loading = true;
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setmovimentimagazzino",
          token: localStorage.user_token,
          movimento: [movimento],
        },
      };
      await this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Placing Salvato");
            this.loading = false;
          } else {
            this.$refs.SnackbarQV.print("error", "Placing non Salvato");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          if (err) {
            this.$refs.SnackbarQV.print("error", "Placing non Salvato");
          }
        });
      this.placingDialog = false;
    },
    closePlacing() {
      this.placingDialog = false;
    },
    closeStoricoPrelievi() {
      this.dialog_storico_prelievi = false;
      this.performPopQuery(this.createStdQueryArr(this.workorder));
    },
    createStdQueryArr(arg_obj) {
      const arr_params = [{ name: "id_utente", value: localStorage.id }];

      for (let field in arg_obj) {
        if (field != "autorizzazioni" && field != "immagine_preview") {
          arr_params.push({
            name: field,
            value: arg_obj[field],
          });
        }
      }

      return arr_params;
    },
    fermaLavorazioneTeam(arg) {
      /* Chiedo le persone che hanno le competenze per lavorare
       * su questa fase; alcune di loro possono avere già uno
       * start / stop. In base ai dati, andrò a comunicare al BE
       * dei nuovi stop sugli operatori debiti. */
      const request_get = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessatempisquadra",
          token: localStorage.user_token,
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
        },
      };

      return this.$store
        .dispatch("api", request_get)
        .then((res) => {
          if (res.status === 200) {
            /* Mi metto da parte solo gli operatori già presenti sul
             * DB che abbiano un'ora di start ma non una di stop. */
            const arr_tmp = new Array();
            res.data.squadra.forEach((e) => {
              if (
                e.id_commessa_tempi_squadra != -1 &&
                e.ora_inizio != null &&
                e.ora_fine == null
              ) {
                e.ora_fine = new moment().format("YYYY-MM-DD HH:mm:ss");
                arr_tmp.push(Object.assign({}, e));
              }
            });

            /* Se arr_tmp era vuoto ritorno true, e fine; se
             * invece era popolato faccio ancora la chiamata di
             * set per modificare le ore di stop degli operatori. */
            if (arr_tmp.length > 0) {
              const request_set = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                  action: "setcommessatempisquadra",
                  token: localStorage.user_token,
                  squadra: arr_tmp,
                },
              };

              return this.$store
                .dispatch("api", request_set)
                .then((res) => {
                  if (res.status === 200) {
                    return true;
                  } else {
                    this.$refs.SnackbarQV.print(
                      "orange",
                      "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );

                    return false;
                  }
                })
                .catch((e) => {
                  console.error(e);
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                  );

                  return false;
                });
            } else {
              // Se arr_tmp era vuoto ritorno true, e fine;
              return true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    formatData(arg) {
      if (arg == null || arg == "") {
        return "N/D";
      } else {
        let strRes = "";
        strRes += arg.substr(8, 2);
        strRes += "/";
        strRes += arg.substr(5, 2);
        strRes += "/";
        strRes += arg.substr(0, 4);
        strRes += " ";
        strRes += arg.substr(11, 1);
        return strRes;
      }
    },
    formattaData(arg) {
      const res = `${arg.substr(8, 2)}/${arg.substr(5, 2)}/${arg.substr(
        0,
        4
      )} ${arg.substr(11, 5)}`;
      return res;
    },
    getMiniaturaH(arg_img, arg_max) {
      return new Promise(function (resolve) {
        const img_tmp = new Image();
        img_tmp.src = arg_img;

        img_tmp.onload = function () {
          // Se i valori sono spanati ritorno 0.
          if (img_tmp.naturalHeight == null || img_tmp.naturalHeight == "") {
            console.warn("L'immagine ha dimensioni nulle.");
            resolve(0);
          }

          const res = new Object();

          // Se l'immagine eccede le dimensioni della miniatura...
          if (
            img_tmp.naturalWidth > arg_max ||
            img_tmp.naturalHeight > arg_max
          ) {
            // Se è larga o quadrata...
            if (
              img_tmp.naturalWidth > img_tmp.naturalHeight ||
              img_tmp.naturalWidth === img_tmp.naturalHeight
            ) {
              res.width = arg_max;
              res.height =
                (res.width * img_tmp.naturalHeight) / img_tmp.naturalWidth;
              resolve(res.height);
            } else if (img_tmp.height > img_tmp.naturalWidth) {
              // Se invece è alta...
              resolve(arg_max);
            }
          } else {
            // Se l'immagine è più piccola della miniatura...
            resolve(img_tmp.naturalHeight);
          }
        };
      });
    },
    async getMiniaturaW(arg_img, arg_max) {
      return new Promise(function (resolve) {
        const img_tmp = new Image();
        img_tmp.src = arg_img;

        img_tmp.onload = function () {
          // Se i valori sono spanati ritorno 0.
          if (img_tmp.naturalWidth == null || img_tmp.naturalWidth == "") {
            console.warn("L'immagine ha dimensioni nulle.");
            resolve(0);
          }

          const res = new Object();

          // Se l'immagine eccede le dimensioni della miniatura...
          if (
            img_tmp.naturalWidth > arg_max ||
            img_tmp.naturalHeight > arg_max
          ) {
            // Se è larga o quadrata...
            if (
              img_tmp.naturalWidth > img_tmp.naturalHeight ||
              img_tmp.naturalWidth === img_tmp.naturalHeight
            ) {
              resolve(arg_max);
            } else if (img_tmp.height > img_tmp.naturalWidth) {
              // Se invece è alta...
              res.height = arg_max;
              res.width =
                (res.height * img_tmp.naturalWidth) / img_tmp.naturalHeight;
              resolve(res.width);
            }
          } else {
            // Se l'immagine è più piccola della miniatura...
            resolve(img_tmp.naturalWidth);
          }
        };
      });
    },
    getRelazioniModuli(arg_id_commessa_dettaglio, arg_cod) {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getrelazionimoduli",
          token: localStorage.user_token,
          codice: arg_cod,
          id_riferimento: arg_id_commessa_dettaglio,
          id_personale: localStorage.id,
          riferimento: "commessa_dettaglio",
          modulo: "questionario",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.result.dati.length > 0) {
              let object = {
                id_relazione: res.data.result.dati[0].id_relazione,
                id_modulo: res.data.result.dati[0].id_start,
                exec: res.data.result.dati[0]._exec,
                id_relazione_log: res.data.result.dati[0].id_relazione_log,
              };
              return object;
            } else {
              return {
                exec: "N",
              };
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    handleClickChiusuraMassivaFasi(arg) {
      this.$emit("click_chiusura_massiva_fasi", arg);
    },
    handleClickRegistraArtRes(arg) {
      this.$emit("click_registra_art_res", arg);
    },
    handleClickRegistraPeso(arg) {
      this.$emit("click_registra_peso", arg);
    },
    handleClickRiaperturaMaster(arg) {
      this.$emit("click_riapertura_master", arg);
    },
    handleClickAllegatiFase(arg) {
      this.$emit("click_allegati_fase", arg);
    },
    handleClickApplicazioneLoghi(arg) {
      this.$emit("click_applicazione_loghi", arg);
    },
    handleClickAvanzaConfezioni(arg) {
      this.$emit("click_avanza_confezioni", arg);
    },
    handleClickAvanzaContenitore(arg) {
      this.$emit("click_avanza_contenitore", arg);
    },
    handleClickAvanzaContenitoreSF(arg) {
      this.$emit("click_avanza_contenitore_sf", arg);
    },
    handleClickCampionatura(arg) {
      this.$emit("click_campionatura", arg);
    },
    handleClickChiusuraFase(arg) {
      this.$emit("click_chiusura_fase", arg);
    },
    handleClickControlloMP(arg) {
      this.$emit("click_controllo_mp", arg);
    },
    handleClickControlloQualita(arg) {
      this.$emit("click_controllo_qualita", arg);
    },
    handleClickGestionePulsanti() {
      this.$emit("click_gestione_pulsanti");
    },
    handleClickHistory(arg) {
      this.$emit("click_history", arg);
    },
    handleClickLavoroSquadra(arg) {
      this.$emit("click_lavoro_squadra", arg);
    },
    handleClickNascondi(arg) {
      this.$emit("click_nascondi", arg);
    },
    handleClickNoteCommessa(arg) {
      this.$emit("click_note_commessa", arg);
    },
    handleClickNoteFase(arg) {
      this.$emit("click_note_fase", arg);
    },
    handleClickNoteFasePrecedente(arg) {
      this.$emit("click_note_fase_precedente", arg);
    },
    handleClickPrelievi(arg) {
      this.$emit("click_prelievi", arg);
    },
    handleClickQuestionarioQualita(arg_wo, arg_questionario) {
      this.$emit("click_questionario_qualita", arg_wo, arg_questionario);
    },
    handleClickRegistraImballi(arg) {
      this.$emit("click_registra_imballi", arg);
    },
    handleClickRegistraPezzi(arg) {
      this.$emit("click_registra_pezzi", arg);
    },
    handleClickManutenzione(arg) {
      this.$emit("click_manutenzione", arg);
    },
    handleClickRegistraFermi(arg) {
      this.$emit("click_registra_fermi", arg);
    },
    handleClickRegistraPezziAlternativi(arg) {
      this.$emit("click_registra_pezzi_alternativi", arg);
    },
    handleClickRegistraPezziSeriali(arg) {
      this.$emit("click_registra_pezzi_seriali", arg);
    },
    handleClickRegistraScarti(arg) {
      this.$emit("click_registra_scarti", arg);
    },
    handleClickRegistraContAlternativi(arg) {
      this.$emit("click_registra_cont_alternativi", arg);
    },
    handleClickRistampaSeriale(arg) {
      this.$emit("click_ristampa_seriale", arg);
    },
    handleClickSegnalazione(arg) {
      this.$emit("click_segnalazione", arg);
    },
    handleClickVisualizzaAllegatoControllo(arg) {
      this.$emit("click_visualizza_allegto_controllo", arg);
    },
    handleClickVisualizzaDisegno(arg) {
      this.$emit("click_visualizza_disegno", arg);
    },
    handleClickSchedaPackaging(arg) {
      this.$emit("click_scheda_packaging", arg);
    },
    handleClickSchedaRichieste(arg) {
      this.$emit("click_scheda_richieste", arg);
    },
    handleClickStart() {
      this.$emit("click_start");
    },
    handleClickStop(commessa, arg_nascondi, arg_dialog) {
      this.$emit("click_stop", commessa, arg_nascondi, arg_dialog);
    },
    handleClickSubentro(arg) {
      this.$emit("click_subentro", arg);
    },
    handleColumnIsMounted(arg) {
      this.$emit("column_is_mounted", arg);
    },
    async nascondiWO() {
      // Chiudo il dialog di conferma.
      this.conferma_nascondi = false;

      // Se il WO è fermo nascondo l'oggetto...
      if (
        this.workorder_sel.ora_start == null ||
        (this.workorder_sel.ora_start != null &&
          this.workorder_sel.ora_stop != null)
      ) {
        await this.performPreQuery(
          "NWO",
          this.createStdQueryArr(this.workorder_sel)
        );
        this.$emit("click_nascondi", this.workorder_sel);
      } else {
        /* ... Se invece è attivo prima do uno stop e
         * faccio registrare, poi lo nasconderò. */
        await this.performPreQuery(
          "NWO",
          this.createStdQueryArr(this.workorder_sel)
        );
        this.switchStartStop(this.workorder_sel, "nascondi", "on", "dialog_on");
      }
    },
    performPopQuery(arr_parametri) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setqueryevent",
          token: localStorage.user_token,
          tipo: "post",
          codice: this.$store.state.stack_query.pop(),
          params: arr_parametri,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            return true;
          } else {
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    performPreQuery(arg_cod_pulsante, arg_parametri) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setqueryevent",
          token: localStorage.user_token,
          tipo: "pre",
          codice: arg_cod_pulsante,
          params: arg_parametri,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$store.state.stack_query.push(arg_cod_pulsante);
            return true;
          } else {
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    selectPlacingUbicazione() {
      console.log("test");
    },
    sendPartProgram() {
      this.$refs.GestioneFasiValori.getPpJSON();
    },
    setCommessaTempi(commessa, start_stop, arg_nascondi, arg_emit, arg_dialog) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessatempi",
          token: localStorage.getItem("user_token"),
          id_commessa: commessa.id_commessa,
          id_commessa_dettaglio: commessa.id_commessa_dettaglio,
          id_macchina: commessa.id_macchina,
          start: start_stop,
          id_causale: 55,
        },
      };

      const that = this;
      return new Promise((resolve) => {
        that.$store.dispatch("api", request).then(() => {
          that.overlay = false;
          if (start_stop == 0) {
            if (arg_emit === "on") {
              that.$emit("click_stop", commessa, arg_nascondi, arg_dialog);
            }
          } else {
            if (arg_emit === "on") {
              that.$emit("click_start");
            }
          }
          resolve();
        });
      });
    },
    showImageViewer() {
      /* Se la mia variabile locale per i dati dell'allegato è
       * già valorizzata, carico questi dati. Se invece non è valorizzata
       * ma sono stato in grado di cliccare sulla miniatura, vuol dire che
       * in passato ho salvato un'immagine e quindi chiedo al BE di mandarmela. */
      if (this.image_for_viewer != null && this.image_for_viewer != "") {
        this.$viewerApi({
          options: {
            toolbar: true,
            url: "data-source",
            initialViewIndex: 0,
          },
          images: [{ "data-source": this.image_for_viewer }],
        });
      } else {
        const request = {
          controller: "Global",
          method: "POST",
          richiesta: {
            action: "getallegati",
            token: localStorage.user_token,
            id_riferimento: this.workorder.id_articolo,
            tipo: "ARTICOLO",
          },
        };

        this.$store
          .dispatch("api", request)
          .then((res) => {
            this.overlay = false;
            if (res.status === 200) {
              const res_tmp =
                res.data.result.allegati[res.data.result.allegati.length - 1];

              const request2 = {
                controller: "Global",
                method: "POST",
                richiesta: {
                  action: "getbase64bypath",
                  token: localStorage.user_token,
                  path:
                    localStorage.dbname +
                    "_ARTICOLO_" +
                    res_tmp.id_allegato +
                    "." +
                    res_tmp.estensione,
                },
              };

              this.$store
                .dispatch("api", request2)
                .then((res2) => {
                  this.overlay = false;
                  if (res2.status === 200) {
                    this.image_for_viewer = res2.data.result;

                    // L'immagine in alta definizione valorizza la mia variabile di supporto
                    this.$viewerApi({
                      options: {
                        toolbar: true,
                        url: "data-source",
                        initialViewIndex: 0,
                      },
                      images: [{ "data-source": this.image_for_viewer }],
                    });
                  } else {
                    this.$refs.SnackbarQV.print(
                      "orange",
                      "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                  }
                })
                .catch((e2) => {
                  console.error(e2);
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                  );
                });
            }
          })
          .catch((e) => {
            console.error(e);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          });
      }
    },
    async switchStartStop(
      elem,
      arg_nascondi,
      arg_emit,
      arg_dialog,
      arg_cod_pulsante
    ) {
      // Controllo se ci sono questionari per questo pulsante.
      let that = this;

      const stack_obj = {
        funzione: function () {
          that.switchStartStop(
            elem,
            arg_nascondi,
            arg_emit,
            arg_dialog,
            arg_cod_pulsante
          );
        },
      };

      const res = await this.handleClickCheck(
        elem,
        arg_cod_pulsante,
        stack_obj
      );

      if (res === "S") {
        return;
      }

      /* Se arrivo qui è perché non ho bisogno di rispondere a nessun
       * questionario e posso eseguire la normale logica del metodo. */

      /* Faccio un controllo per verificare che in questo
       * momento la macchina sia effettivamente disponibile. */
      const chk_disponibilita = await this.chkDisponibilita(elem);
      if (chk_disponibilita != null && chk_disponibilita != "") {
        this.$refs.SnackbarQV.print(
          "orange",
          `La lavorazione del Work Order risulta impegnata da ${chk_disponibilita}.`
        );
        return;
      }

      /* Faccio scattare l'overlay di caricamento,
       * poi le varie chiamate lo sbloccheranno. */
      this.overlay = true;

      if (
        elem.ora_start == null ||
        (elem.ora_start != null && elem.ora_stop != null)
      ) {
        // Se l'ho visto, stabilisco che ora è
        let adesso = moment();
        let orario_attivazione =
          adesso.date() +
          "/" +
          ("0" + (adesso.month() + 1)).substr(-2) +
          "/" +
          adesso.year() +
          " " +
          ("0" + adesso.hour()).substr(-2) +
          ":" +
          ("0" + adesso.minutes()).substr(-2);

        // Aggiorno il work order
        elem.ora_start = orario_attivazione;
        elem.ora_stop = null;

        // Eseguo la prequery.
        await this.performPreQuery("ST-ST", this.createStdQueryArr(elem));

        // Mando al backend l'aggiornamento
        await this.setCommessaTempi(
          elem,
          "1",
          arg_nascondi,
          arg_emit,
          arg_dialog
        );
      } else {
        // Se ho finito di lavorare, stabilisco che ora è
        let adesso = moment();
        let orario_attivazione =
          adesso.date() +
          "/" +
          ("0" + (adesso.month() + 1)).substr(-2) +
          "/" +
          adesso.year() +
          " " +
          ("0" + adesso.hour()).substr(-2) +
          ":" +
          ("0" + adesso.minutes()).substr(-2);

        // Aggiorno l'oggetto
        elem.ora_stop = orario_attivazione;

        /* Se la gestione del team è abilitata, faccio una chiamata
         * per segnare stop su tutti i membri del team attivi. */
        if (this.gestione_team_enabled == 1) {
          await this.fermaLavorazioneTeam(elem);
        }

        // Eseguo la prequery.
        await this.performPreQuery(
          arg_cod_pulsante,
          this.createStdQueryArr(elem)
        );

        // Mando al backend l'aggiornamento
        await this.setCommessaTempi(
          elem,
          "0",
          arg_nascondi,
          arg_emit,
          arg_dialog
        );

        // Riporto i campi di start e stop a null
        elem.ora_start = null;
        elem.ora_stop = null;
      }

      this.performPopQuery(this.createStdQueryArr(elem));
    },
    transmitClickCheck(wo, cod_btn) {
      this.$emit("click_check", wo, cod_btn);
    },
  },
  created() {},
  mounted() {
    this.$emit("column_is_mounted", this.switchStartStop);
  },
};
</script>
<style scoped>
</style>